import _ from 'lodash';
// import errorCode from './errorCode';
import toast from '../components/ToastMtd';
import route from '../router';

const errorHandler = {};

errorHandler['106'] = () => {
    // Vue.$store.dispatch('toast', '请先登录');
    setTimeout(() => {
        route.push({
            path: '/login'
        });
        toast('请先登录');
    }, 1);
};

// errorHandler.common = (err, opt) => {
//     const errMsg = err.errmsg || errorCode[err.errcode] || '未定义错误';

//     if (!opt || !opt.noToast) {
//         // Vue.$store.dispatch('toast', errMsg);
//         toast(errMsg);
//     }
// };

const handleError = (err, /* opt = null */) => {
    const errCode = err.errcode;

    if (_.has(errorHandler, errCode)) {
        errorHandler[errCode]();
    } else {
        // errorHandler.common(err, opt);
    }
};

export default handleError;



// WEBPACK FOOTER //
// ./src/http/apiErrorHandler.js